import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs';
import {SelectListResponse, TenantsClient} from '../generated-client/generated-api-client';
import {ErrorProcessorService} from './error-processor.service';
import {Router} from "@angular/router";

@Injectable({
  providedIn: 'root',
})
export class TenantService {
  tenantId = new BehaviorSubject<string | undefined>(undefined);
  tenantSelectList = new BehaviorSubject<SelectListResponse | undefined>(undefined);

  constructor(private _errorProcessorService: ErrorProcessorService,
              private _router: Router,
  ) {}

  public setActiveTenantId(tenantId: string): void {
    // ha nem első bejelentkezés és változott a localStorage-ben tárolttal, a 'főoldalra' irányítjuk
    const isReloadNeeded = localStorage.activeTenantId != undefined && tenantId !== localStorage.activeTenantId;
    localStorage.activeTenantId = tenantId;
    this.tenantId.next(tenantId);

    if (isReloadNeeded) {
      this._router.navigate(['/']);
    }
  }

  public clearActiveTenantId() {
    localStorage.removeItem('activeTenantId');
    this.tenantId.next(undefined);
  }

  public refreshTenantSelectList(client: TenantsClient) {
    client.tenants().subscribe(
      response => {
        this.tenantSelectList.next(response);
      },
      error => this._errorProcessorService.processError(error)
    );
  }

  get activeTenantId(): string | undefined {
    return localStorage.activeTenantId;
  }
}
